import { render, staticRenderFns } from "./EmailListSingleValue.vue?vue&type=template&id=279860c9"
import script from "./EmailListSingleValue.vue?vue&type=script&lang=ts"
export * from "./EmailListSingleValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports